import { Component } from '@angular/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { DashboardApiDataService } from '../../dashboard/dashboard-api.service';

@Component({
    selector: 'app-master-search',
    imports: [SharedModule],
    templateUrl: './master-search.component.html',
    styleUrl: './master-search.component.scss'
})
export class MasterSearchComponent {

  constructor(
    private dashboardApiService: DashboardApiDataService
  ) { }

  isSubmitEnabled: boolean = false;
  form: FormGroup = new FormGroup({
    kit: new FormControl(''),
    store: new FormControl('')
  });
  loader: boolean = false;
  errorMessage: string = '';
  successMessage: string = '';
  currentOrg: string = '';
  multiple3PL: any;

keyup(){
  const regex = /[a-zA-Z&!@#$%^*()_+={}]/;
  if(regex.test(this.form.value.kit)){
    this.form.controls['kit'].patchValue('');
  }
  if(regex.test(this.form.value.store)){
    this.form.controls['store'].patchValue('');
  }
  this.form.controls['kit'].patchValue(this.form.value.kit.replace(/\s/g, ""));
  this.form.controls['store'].patchValue(this.form.value.store.replace(/\s/g, ""));
  if(this.form.value.kit.length || this.form.value.store.length){
    if(this.form.value.kit.length){
      this.isSubmitEnabled = this.form.value.kit.length === 5
    }
    if(this.form.value.store.length){
      this.isSubmitEnabled = this.form.value.store.length === 5
    }
    if(this.form.value.kit.length && this.form.value.store.length){
      this.isSubmitEnabled = this.form.value.store.length === 5 && this.form.value.kit.length === 5
    }
  }
  
  else{
    this.successMessage = '';
    this.isSubmitEnabled = false;
  }
}

paste(){
  const regex = /[a-zA-Z]/;
  setTimeout(() => {
    if(regex.test(this.form.value.kit)){
      this.form.controls['kit'].patchValue('');
    }
    if(regex.test(this.form.value.store)){
      this.form.controls['store'].patchValue('');
    }
    this.keyup();
  }, 0);
}


  onSearch(){
    const PAYLOAD = {
      kit: this.form.value.kit? this.form.value.kit : null,
      storeId: this.form.value.store? this.form.value.store : null
    };
    this.loader = true;
    this.currentOrg = sessionStorage.getItem('org') || '';
    
    this.dashboardApiService.getMasterSearchData(PAYLOAD).subscribe((res:any)=>{
      this.loader = false;
      if(res && res.length){
        if(res.length === 1){
          if(res[0] === this.currentOrg){
            this.successMessage = 'You are already viewing the matching 3PL.';
            setTimeout(() => {
              this.successMessage = '';
            }, 5000);
            return;
          }
          else{
            const orgList = sessionStorage.getItem('allowedOrgs')? JSON.parse(sessionStorage.getItem('allowedOrgs') || '[]') : [];
            const orgIndex = orgList.findIndex((_: any) => _.threeplId === res[0]);
            sessionStorage.setItem('currentLob', orgList[orgIndex]?.lobs[0] || 'HALLOWEEN');
            sessionStorage.setItem('currentProfile', '1');
            sessionStorage.setItem('org', res[0]);
            setTimeout(() => {
              window.location.reload();
            }, 0);
            this.errorMessage = '';
          }
        }
        else{
          this.multiple3PL = res;
          this.successMessage = `Multiple 3PLs found. Click the 3PL to see detail.`;        
        }
      }
      else{
        this.errorMessage = 'No matching 3PL with your search criteria.';
        setTimeout(() => {
          this.errorMessage = '';
        }, 5000);
      }
    });
  }

  redirectToOrg(org: string){
    const orgList = sessionStorage.getItem('allowedOrgs')? JSON.parse(sessionStorage.getItem('allowedOrgs') || '[]') : [];
    const orgIndex = orgList.findIndex((_: any) => _.threeplId === org);
    sessionStorage.setItem('currentLob', orgList[orgIndex]?.lobs[0] || 'HALLOWEEN');
    sessionStorage.setItem('currentProfile', '1');
    sessionStorage.setItem('org', org);
    setTimeout(() => {
      window.location.reload();
    }, 0);
    this.errorMessage = '';
  }
}
